export default __webpack_public_path__ + "static/media/options-icon.ad03c90b.svg";